export const TOAST_DURATION = 10000;

export const ORDER = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export const REPORT_PLATFORM = {
  WEB: 'web',
  MOBILE: 'mobile',
} as const;

export const REPORT_PRIORITY = {
  LOW: 'Low',
  MED: 'Medium',
  HIGH: 'High',
} as const;

export const REPORT_STATUS = {
  REPORTED: 'To Do',
  IN_PROGRESS: 'In Progress',
  DONE: 'Done',
} as const;

export const REPORT_ENV = {
  DEV: 'dev',
  TEST: 'test',
  PROD: 'prod',
} as const;

export const BROWSERS = {
  CHROME: 'Google Chrome',
  SAFARI: 'Safari',
  FIREFOX: 'Firefox',
  EDGE: 'Microsoft Edge',
  OTHER: 'Other',
} as const;

export const ENDPOINTS = {
  VALIDATE: '/auth/profile',
  REFRESH: '/auth/refresh',
  SCREENSHOT: '/screenshots',
  LOGIN: '/auth/signin',
  LOGOUT: '/auth/logout',
  SIGNUP: '/auth/signup',
  PROJECT: '/projects',
  REPORT: '/reports',
  USER: '/users',
  PASSWORD: '/auth/set-password',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  UPDATE_LANGUAGE: '/users/language',
  PROJECT_USERS: (id: string) => `/project/${id}/users`,
} as const;

export const REPORT_ORDER_OPTIONS = [
  { direction: ORDER.ASC, field: 'createdAt', label: 'order.createdAtAsc' },
  { direction: ORDER.DESC, field: 'createdAt', label: 'order.createdAtDesc' },
] as const;

export const USERS_ORDER_OPTIONS = [
  { direction: ORDER.ASC, field: 'createdAt', label: 'order.createdAtAsc' },
  { direction: ORDER.DESC, field: 'createdAt', label: 'order.createdAtDesc' },
] as const;

export const ARROW_RIGHT_KEY = 'ArrowRight';
export const ARROW_LEFT_KEY = 'ArrowLeft';

export const QUERY_KEYS = {
  PROJECTS: 'projects',
  REPORTS: 'reports',
  REPORT: 'report',
  USERS: 'users',
  PROJECT: 'project',
  CLIENTS: 'clients',
  USER: 'user',
  STATUSES: 'statuses',
  AUTH: 'auth',
};

export const USER_ROLE = {
  CLIENT: 'client',
  SUPERADMIN: 'superadmin',
} as const;

export const PROJECT_STATUS = {
  CREATED: 'created',
  DEVELOP: 'develop',
  DONE: 'done',
  ARCHIVED: 'archived',
} as const;

export const PROJECT_ORDER_OPTIONS = [
  { direction: ORDER.ASC, field: 'createdAt', label: 'order.createdAtAsc' },
  { direction: ORDER.DESC, field: 'createdAt', label: 'order.createdAtDesc' },
] as const;

export const ERROR_CODES = {
  400: '400',
  401: '401',
  403: '403',
  404: '404',
  500: '500',
};

export const ERROR_PAGES = [
  {
    title: 'error400.title',
    name: '400',
    description: 'error400.description',
    path: '/400',
  },
  {
    title: 'error401.title',
    name: '401',
    description: 'error401.description',
    path: '/401',
  },
  {
    title: 'error403.title',
    name: '403',
    description: 'error403.description',
    path: '/403',
  },
  {
    title: 'error404.title',
    name: '404',
    description: 'error404.description',
    path: '*',
  },
  {
    title: 'error500.title',
    name: '500',
    description: 'error500.description',
    path: '/500',
  },
] as const;
